<template>
  <div>
    <v-card>
      <v-card-actions class="virtual-trade-color">
        <div>VIRTUAL TRADE</div>
      </v-card-actions>
      <v-card-title class="px-8 pt-8">
        <v-row>
          <v-col cols="6">
            <div class="security">{{ trade_data.security }}</div>
            <div>
              <div class="card-live">
                <span class="primary--text text-uppercase card-live-txt">{{
                  trade_data.trade_type
                }}</span>
                <span class="card-live-txt">
                  @{{ trade_data.entry_price }}
                </span>
                <span> ● </span>
                <span class="text-capitalize"> {{ trade_data.lots }} Qty </span>
                <span>●</span>
                <span class="text-capitalize"> {{ trade_data.product }} </span>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="d-flex justify-end align-start">
              <div class="posted">Posted</div>
              <div class="verticle mx-4">|</div>
              <div class="date">{{ getTime(trade_data.created) }}</div>
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-8 py-8">
        <v-row>
          <v-col cols="4">
            <div>
              <div class="ets-label">
                <div>
                  Entry Price
                  <span style="margin-left: -7px">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          right
                          v-bind="attrs"
                          v-on="on"
                          color="#828282"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        As intermediate targets are achieved, <br />
                        the previous target acts as a stop loss
                        <br />to secure unrealised profits.
                      </span>
                    </v-tooltip>
                  </span>
                </div>
              </div>
              <div class="ets-price">₹{{ trade_data.entry_price }}</div>
            </div>
          </v-col>
          <v-col cols="4" class="d-flex justify-center">
            <div>
              <div class="ets-label">
                Target

                <span style="margin-left: -7px">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        right
                        v-bind="attrs"
                        v-on="on"
                        color="#828282"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>
                      As intermediate targets are achieved, <br />
                      the previous target acts as a stop loss
                      <br />to secure unrealised profits.
                    </span>
                  </v-tooltip>
                </span>
              </div>
              <div class="ets-price">₹{{ trade_data.target_price }}</div>
            </div>
          </v-col>
          <v-col cols="4" class="d-flex justify-end">
            <div>
              <div class="ets-label">
                Stoploss

                <span style="margin-left: -7px">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        right
                        v-bind="attrs"
                        v-on="on"
                        color="#828282"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>
                      As intermediate targets are achieved, <br />
                      the previous target acts as a stop loss
                      <br />to secure unrealised profits.
                    </span>
                  </v-tooltip>
                </span>
              </div>
              <div class="ets-price">₹{{ trade_data.stop_loss }}</div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <div v-if="trade_data.reasoning" class="reasoning-content">
          <div v-if="!desMore">
            {{ trade_data.reasoning.substring(0, 85) }}...
            <span
              v-if="trade_data.length > 100"
              class="show_more"
              @click="desMore = !desMore"
              >See more</span
            >
          </div>
          <div v-else>
            <span v-if="trade_data.reasoning">{{ trade_data.reasoning }}</span>
            <span
              v-if="trade_data.length > 100"
              class="show_more"
              @click="desMore = !desMore"
              >See less</span
            >
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-1 justify-space-between card-actions">
        <div class="d-flex align-center">
          <div>
            <!-- <v-avatar v-if="!trade_card.user_image" color="#f5f5f5">
              <div class="user-image">
                {{ getCharacter(trade_card.posted_by_name) }}
              </div>
            </v-avatar> -->
            <v-avatar>
              <div class="user-image">
                <v-img class="users-img" :src="deefault_user"> </v-img>
              </div>
            </v-avatar>
          </div>
          <div :class="$vuetify.breakpoint.xsOnly ? 'ml-2' : 'ml-4'">
            <div class="d-flex mb-2 justify-start flex-column">
              <!-- v-if="trade_card.posted_by_group" -->
              <div class="card-user-name" @click="goToGroup(trade_data.id)">
                {{ removeLastName(trade_data.group_name) }}
                <v-icon
                  class="ml-2"
                  small
                  :x-small="$vuetify.breakpoint.xsOnly"
                  color="grey"
                  >mdi-account-group</v-icon
                >
              </div>
              <!-- v-else -->
              <div class="card-username">
                <!-- @click="goToProfile($event, trade_data.posted_by)" -->
                By {{ trade_data.posted_by }}
                <!-- {{ removeLastName(trade_card.posted_by) }} -->
              </div>
              <!-- <v-img
                v-if="trade_card.is_sebi_registered"
                class="ml-2"
                :src="verified"
                width="1.125rem"
                height="1.125rem"
              ></v-img> -->
            </div>
          </div>
        </div>

        <div :class="$vuetify.breakpoint.xsOnly ? 'd-flex' : ''">
          <v-btn
            elevation="0"
            class="mx-1 share"
            style="margin-top: -2px"
            v-if="is_same_user"
            :small="$vuetify.breakpoint.xsOnly"
            :loading="featuredBtnLoader"
            @click="addOrRemoveToFeatured(trade_data)"
          >
            <v-icon
              color="#F2C94C"
              v-if="trade_data.is_featured"
              :small="$vuetify.breakpoint.xsOnly"
              >mdi-star</v-icon
            >
            <!-- v-if="trade_data.is_featured" -->
            <v-icon :small="$vuetify.breakpoint.xsOnly" color="0f0f0f" v-else
              >mdi-star-outline</v-icon
            >
          </v-btn>
          <v-btn
            @click="deleteTrade()"
            :small="$vuetify.breakpoint.xsOnly"
            v-if="is_same_user"
            class="mx-1 share"
            elevation="0"
          >
            <v-icon :small="$vuetify.breakpoint.xsOnly" color="0f0f0f"
              >mdi-trash-can-outline</v-icon
            >
          </v-btn>

          <v-btn
            @click="
              shareTrade(
                trade_data.id,
                trade_data.posted_by,
                trade_data.trade_type,
                trade_data.security,
                trade_data.posted_by_id
              )
            "
            :small="$vuetify.breakpoint.xsOnly"
            class="mx-1 share"
            elevation="0"
          >
            <v-icon :small="$vuetify.breakpoint.xsOnly" color="0f0f0f"
              >mdi-share-variant-outline</v-icon
            >
          </v-btn>
          <v-badge
            class="mr-2"
            v-if="trade_data.comments_count"
            bordered
            color="error"
            :content="trade_data.comments_count"
            overlap
          >
            <v-btn
              :small="$vuetify.breakpoint.xsOnly"
              @click="openComment()"
              class="mx-1 share"
              elevation="0"
            >
              <v-icon :small="$vuetify.breakpoint.xsOnly" color="0f0f0f"
                >mdi-comment-multiple-outline</v-icon
              >
            </v-btn>
          </v-badge>
          <!-- <v-btn
            :small="$vuetify.breakpoint.xsOnly"
            @click="openComment()"
            class="mx-1 share"
            elevation="0"
          >
            <v-icon :small="$vuetify.breakpoint.xsOnly" color="0f0f0f"
              >mdi-comment-multiple-outline</v-icon
            >
          </v-btn> -->
        </div>
      </v-card-actions>
      <v-expansion-panels v-model="comment">
        <v-expansion-panel>
          <v-expansion-panel-content class="comment-panel">
            <CommentsCard
              @close-comment="closeComment"
              @count-comment="countComment"
              :trade_detail_form="trade_data"
              :isFOTrade="true"
            >
            </CommentsCard>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <confirm-trade-delete-form :delete_data="delete_data">
    </confirm-trade-delete-form>
  </div>
</template>

<script>
import CommentsCard from "@/components/OpenCommentPanel.vue";
import dayjs from "dayjs";
// import apiUrl from "@/common/apiUrl";
import { mapActions } from "vuex";
import Axios from "@/api/BaseAxios.js";
import helper from "@/helper";

export default {
  name: "FOTradecard",
  props: {
    trade_data: {
      type: Object,
      required: true,
    },
  },
  components: {
    CommentsCard,

    "confirm-trade-delete-form": () =>
      import("@/components/Trade/ConfirmTradeDeleteForm.vue"),
  },
  data() {
    return {
      comment: null,
      trade_card: "",
      featuredBtnLoader: false,
      desMore: false,
      dotsGroup: require("../assets/images/dotGroup.svg"),
      deefault_user: require("@/assets/images/Default User.svg"),
      noImage_logo: require("@/assets/images/No-img-logo.svg"),
      delete_data: {
        flag: false,
        id: null,
        isFnO: false,
      },
      reasoning:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus perspiciatis sunt rerum quidem nostrum minima quas animi perferendis. Cumque unde mollitia molestiae ratione illum tempore officiis optio adipisci tempora modi. ",
    };
  },
  computed: {
    is_same_user() {
      const user_id = localStorage.getItem("user_id");
      // return user_id;
      return Number(user_id) === Number(this.trade_data.posted_by_id);
    },

    isTradeUpcoming() {
      return this.trade_data.status == "Inactive";
    },
  },
  methods: {
    ...mapActions({
      snackBar: "snackBar/showSnack",
      toggleTradeModal: "tradeCardDialog/toggleModal",
    }),

    getTime(value) {
      return dayjs(value).format("h:mm A D MMM");
    },
    closeComment(value) {
      this.comment = value;
    },
    countComment(value) {
      console.log(value);
      this.trade_card.comments_count = value;
    },
    openComment() {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("trade_detail_comment");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_trade_detail_comment");
        }
      }
      if (this.comment == null) {
        this.comment = 0;
      } else {
        this.comment = null;
      }
    },
    goToGroup(id) {
      this.$router.push({
        name: "premiumGroup",
        params: {
          id: id,
        },
      });
    },

    shareTrade(id, posted_by, type, trade_name, user_id) {
      // this.toggleTradeModal({ isFOTrade: true });
      const title = "Covesto";
      const text = `Hello, ${posted_by} has shared a trade recommendation on Covesto. ${type} ${trade_name}
            To know more details and get live updates, follow the trade at `;
      // const url = `https://covesto.in/trade/${id}/${trade_name}`;

      const url = `${location.origin}/profile/${user_id}/${posted_by}/?fotrade=true&trade_id=${id}&trade_name=${trade_name}`;

      // console.log(u_url);

      helper.shareLink(url, text, title);

      this.$logEvent("trade_card_share");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_trade_card_share");
      }
    },

    deleteTrade() {
      console.log("delete trade");
      this.delete_data.id = this.trade_data.id;
      this.delete_data.flag = true;
      this.delete_data.isFnO = true;
    },
    removeLastName(value) {
      if (window.innerWidth <= "768" && value.split(" ").length > 1) {
        console.log(value.split(" ").length);
        return `${value.split(" ", 1)[0]} ${value
          .split(" ", -1)
          .pop()
          .substring(0, 1)}.`;
      } else {
        return value;
      }
    },
    addOrRemoveToFeatured(item) {
      this.featuredBtnLoader = true;
      const successHandler = (res) => {
        console.log(res);
        item.is_featured = !item.is_featured;
        this.trade_data = item;
        this.featuredBtnLoader = false;
        let msg;
        if (item.is_featured) {
          msg = "Trade added to featured sections successfully";
        } else {
          msg = "Trade removed to featured sections successfully";
        }
        this.snackBar({
          text: msg,
          color: "success",
          timeout: 4500,
        });
        // this.eventBus.$emit("reload-trades");
        // this.eventBus.$emit("refresh-trade-list");

        // this.$logEvent("feature_trade_posted");
        // if (this.$vuetify.breakpoint.xsOnly) {
        //   this.$logEvent("mweb_feature_trade_posted");
        // }
      };
      const failureHandler = () => {
        this.featuredBtnLoader = false;
      };
      let formData = {};
      formData["id"] = item.id;
      formData["is_featured"] = !item.is_featured;
      formData["request_type"] = "featured";
      Axios.request_PATCH(
        "api/trade/fando-trade-patch",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn:not(.v-btn--round).v-size--default.share {
  min-width: 0px;
  padding: 0 8px;
}
.card-user-name {
  cursor: pointer;
  color: #000;
  font-size: 0.9125rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.reasoning-content {
  font-family: Avenir;
  font-size: 13px;
  font-weight: 800;
  line-height: 17.76px;
  text-align: left;
}
.show_more {
  cursor: pointer;
  font-family: Avenir;
  font-size: 13px;
  font-weight: 800;
  line-height: 17.76px;
  text-decoration-line: underline;
  color: #2d8cff;
}
::v-deep.comment-panel > .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
.card-username {
  font-family: Avenir;
  font-size: 10px;
  font-weight: 800;
  line-height: 13.66px;
  text-align: left;
  color: #333333b2;
}
.ets-price {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 800;
  line-height: 21.86px;
  text-align: left;
  color: #333333;
}
.ets-label {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 800;
  line-height: 19.12px;
  text-align: left;
  color: #333333d6;
}

.card-live-txt {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 800;
  line-height: 19.12px;
  text-align: center;
  //   color: #2d8cff;
}
.date {
  font-family: Avenir;
  font-size: 12px;
  font-weight: 800;
  line-height: 15.03px;
  letter-spacing: -0.03em;
  text-align: center;
  color: #333333de;
}
.verticle {
  font-size: 12px;
  color: #c2c2c2;
  font-size: 12px;
  font-weight: 800;
  line-height: 15.03px;
  letter-spacing: -0.03em;
  text-align: center;
}
.posted {
  font-family: Avenir;
  font-size: 12px;
  font-weight: 800;
  line-height: 16.39px;
  letter-spacing: -0.03em;
  text-align: center;
  color: #33333399;
}
.virtual-trade-color {
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg, #3b3c5d 0%, #7277f1 100%);

  div {
    color: #fff;
    text-align: center;
    font-size: 0.6875rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.02063rem;
  }
}
.card-live > span:not(:nth-of-type(1)):not(:nth-of-type(2)):nth-of-type(n) {
  font-size: 0.63rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}
.security {
  font-family: Avenir;
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
  text-align: left;
  color: #333333;
}
</style>
